import { useCallback, useEffect, useRef } from "react";
import { useSWRConfig } from "swr";
import { sys } from "@/Core/utils/system";
import { isRechargePaymentSuccessTrade } from "./rechargeLotteryTrade";

export const isRechargeParamsRefreshTrade = (tradeModeCode?: string) =>
  isRechargePaymentSuccessTrade(tradeModeCode) ||
  tradeModeCode === "FIRST_RECHARGE_REBATE" ||
  tradeModeCode === "DAY_RECHARGE_REBATE";

export const getRechargeParamsKey = (
  kind: "flat" | "crypto",
  token: string,
  params?: { currencyType?: string; device?: number },
) =>
  token && params?.currencyType
    ? `change${kind === "flat" ? "Flat" : "Crypto"}Recharge?${token}?${JSON.stringify(params)}`
    : null;

// Payment and rebate notifications can arrive together. Revalidate once, without
// clearing mounted forms or treating a rebate as another successful payment.
export function useRechargeParamsRefresh(token: string, isLogin: boolean) {
  const { mutate } = useSWRConfig();
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), [token, isLogin]);

  return useCallback(() => {
    if (!isLogin || !token) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (sys.token !== token) return;
      const prefixes = [
        `changeFlatRecharge?${token}?`,
        `changeCryptoRecharge?${token}?`,
      ];
      void mutate(
        (key) => typeof key === "string" && prefixes.some((prefix) => key.startsWith(prefix)),
      ).catch(() => {
        // Request errors remain available through the corresponding SWR hook.
        console.warn("[recharge-params] refresh failed");
      });
    }, 1000);
  }, [isLogin, mutate, token]);
}
